import { Map } from 'immutable';

function updateToken(state, payload) {
  return state.set('token', payload.token).set('email', payload.email);
}

function updateTokenVerificationError(state, message) {
  return state.set('tokenError', message);
}

export default function (state = Map(), action) {
  switch (action.type) {
    case 'UPDATE_TOKEN':
      return updateToken(state, action.payload);
    case 'UPDATE_TOKEN_VERIFICATION_ERROR':
      return updateTokenVerificationError(state, action.message);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/resetPassword.js